import { OrgId, SchoolyearId } from 'app/common/types/id'
import { getSchoolYear } from 'app/dataProviders/schoolyear'

let schoolYearsAbortController: AbortController | undefined
export const getFilterSchoolYears = async (params: { orgId: OrgId }) => {
  schoolYearsAbortController?.abort()
  schoolYearsAbortController = new AbortController()

  const res = await getSchoolYear(params, schoolYearsAbortController?.signal)
  console.log({ res })
  if (res) {
    const items = res.map(({ ID, title, current, dateStart, dateFinish }) => ({
      id: ID as SchoolyearId,
      title,
      isCurrent: current,
      dateStart,
      dateFinish,
    }))
    return items
  }
  return []
}
